import angular from 'angular';
import { TriageController } from './triage.controller.js';
import { TriageRuleEditionController } from './triage-rule-edition.controller';
import { triggerEventConfig } from './trigger-event-config.directive';
import { triageAction } from './triage-action.directive';
import { replyToPublicCommentAction } from './reply-to-public-comment-action.directive';
import { TriageService } from './triage.service';



angular
  .module('parameters.triage', [])
  .controller('TriageController', TriageController)
  .controller('TriageRuleEditionController', TriageRuleEditionController)
  .directive('triggerEventConfig', triggerEventConfig)
  .directive('triageAction', triageAction)
  .directive('replyToPublicCommentAction', replyToPublicCommentAction)
  .factory('TriageFactory', TriageService.TriageFactory)
;
